import {Form} from '../modules/Form';
import {event} from '../modules/event';


class PopupForm {
	constructor(initData) {
		this._createElements(initData);
		this._addEvents();
        this._checkHash();
	}

	_createElements(initData){
		this.initData = initData;
		this.wrapper = initData.wrapper;
		this.name = this.wrapper ?  this.wrapper.getAttribute('data-popupForm') : this.initData.name;
		this.btnAll =  []; /* кнопки могут добавляться и удаляться, например когда мы преходим на вкладку комменты */
	}

	_addEvents(){
		var self = this,
            all = document.querySelectorAll('[data-popupForm-btn="'+ this.name +'"]');

		for(var i=0,j=all.length; i<j; i++){
            this.addBtn(all[i]);
		}
	}

    addBtn(btn){
        var self = this;
        this._onBtnClick = function(e){
            e.preventDefault();
            if(self.initData.beforeShowPopup) self.initData.beforeShowPopup();
            self.showPopup.call(self);
        }

        event.add(btn, 'click', this._onBtnClick);
        this.btnAll.push(btn);
    }

    removeBtn(btn){
        event.remove(btn, 'click', this._onBtnClick);

        var arr = this.btnAll,
            i = arr.indexOf(btn);

        arr.splice(i, 1);
    }

	/*
		TODO - оформить по людски
	 * data.cls - Дополнительный класс
	  * */

	getContent(){
		if(this.initData.ajax){
            return new Promise((resolve, reject) => {
                var xhr = new XMLHttpRequest();
                xhr.open("POST", this.initData.ajax, true);
                xhr.setRequestHeader("X-Request-Ajax","1");
                xhr.setRequestHeader("X-Request-Referer", window.location.toString());
                xhr.onload = function(){
                    resolve(xhr.responseText);
                };
                xhr.send('');
            });
		}
        else{
            return Promise.resolve(this.wrapper);
		}
	}

    processingСontent(content){
        return Promise.resolve(content);
    }

	showPopup(data){
		var self = this,
			cls = 'popup-middle ' + (data ? (data.cls || '') : '');

		this.getContent()
			.then(
                (content) => {
                    this.processingСontent(content)
                        .then((content) => {
                            uPopup.closeAll();
                            this.popup = uPopup({
                                addClass:cls,
                                name:this.name,
                                content:content,
                                onopen:(wrapper) => {
                                    this.moduleAll = APP.modules.run(wrapper, 'data-PopupForm-modules');
                                    //
                                    self.formObj = new Form({
                                        wrapper: wrapper.querySelector('form'),
                                        onsuccess:function(data){
                                            self.formObj.resetCaptcha();
                                            self._sendStat();

                                            if (self.initData.onsuccess) self.initData.onsuccess(data);
                                            else location.replace(location.protocol + '//' + location.host + location.pathname);
                                        },
                                        onerror:function(data){
                                            if (self.initData.onerror && !self.initData.onerror(data)) return false;

                                            self.formObj.resetCaptcha();
                                            uPopup({
                                                content:data.message
                                            });
                                        }
                                    });
                                },
                                oncloseBefore: () => {
                                    APP.modules.destroy(this.moduleAll);
                                    self.formObj.destroy();
                                    return true;
                                }
                            });
                        })
                }
            )
	}

    _sendStat(){
        if ( this.name === 'reg' ) {
            try {
                gtag('event', 'send_form', {
                    'event_category': 'auth',
                    'event_label': 'send_sign_up_form'
                });
                console.log('gtag success!');
            } catch (error){
                console.error('gtag error:', error);
            }

        } else if ( this.name === 'auth' ) {
            try {
                gtag('event', 'sign_in', {
                    'event_category': 'auth',
                    'event_label': 'log_in_via_email'
                });
                console.log('gtag success!');
            } catch (error){
                console.error('gtag error:', error);
            }
        }
    }

    _checkHash(){
        if(location.hash === '#!' + this.name) this.showPopup();
    }
}

export {PopupForm};



